import { Link } from "@src/Components/Link"
import { colors } from "@src/theme"
import styled from "styled-components"

interface IBadge {
  color: string
  margin?: string
  cursor?: string
}

enum SeverityColors {
  "CRITICAL" = "#9A002A",
  "HIGH" = "#FF002A",
  "MEDIUM" = "#FF7800",
  "LOW" = "#FFBC30",
  "INFO" = "#0062D9",
}

export const CUSTOM_STYLES: any = {
  rows: {
    style: {
      minHeight: 60,
      backgroundColor: colors.white,
      "&:nth-child(even)": {
        backgroundColor: colors.lightBlue,
      },
    },
  },
  headCells: {
    style: {
      span: {
        fontSize: "13px",
      },
      "&:first-child": {
        justifyContent: "center",
        minWidth: 110,
      },
      "&:nth-child(2)": {
        flex: 3,
        paddingLeft: 13,
        paddingRight: 13,
      },
      "&:nth-child(3)": {
        flex: 2,
        minWidth: 120,
        paddingLeft: 15,
        paddingRight: 15,
      },
      "&:last-child": {
        minWidth: 150,
        paddingLeft: 18,
        paddingRight: 18,
        ".rdt_TableCol_Sortable": {
          flex: "1",
          ">div": {
            width: "100%",
          },
        },
      },
    },
  },
  cells: {
    style: {
      display: "flex",
      alignItems: "baseline",
      "&:first-child": {
        alignItems: "center",
        justifyContent: "center",
        minWidth: 110,
      },
      "&:nth-child(2)": {
        flex: 3,
        paddingLeft: 13,
        paddingRight: 13,
      },
      "&:nth-child(3)": {
        flex: 2,
        minWidth: 120,
        paddingLeft: 15,
        paddingRight: 15,
      },
      "&:last-child": {
        minWidth: 150,
        paddingLeft: 18,
        paddingRight: 18,
      },
    },
  },
}

export const WarningSection = styled.div`
  padding: 16px 0;
  border-radius: 6px;
`
export const CustomTableLink = styled.div`
  color: ${colors.link};
  cursor: pointer;
  white-space: normal;
  font-weight: 700;

  &:hover {
    opacity: 0.7;
  }
`
export const StyledLink = styled(Link)`
  text-decoration: "underline";
`

export const WeaknessesContainer = styled.div`
  max-width: 100%;
  .rdt_TableCell {
    display: flex;
    align-items: center;
  }
`

export const Badge = styled.div<IBadge>`
  color: ${colors.white};
  cursor: ${({ cursor }) => cursor || "pointer"};
  background-color: ${({ color }) =>
    SeverityColors[color.toUpperCase() as keyof typeof SeverityColors]};
  font-size: 13px;
  font-weight: 600;
  line-height: 24px;
  border-radius: 3px;
  width: 62px;
  text-align: center;
  margin: ${({ margin }) => margin};
`

export const LastUpdatedText = styled.span`
  line-height: 30px;
  font-size: 16px;
  font-style: italic;
`

export const StatusText = styled.div`
  cursor: help;
  border-bottom: 1px dashed;
`
